import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button, Table, TableHead, TableBody, TableRow, TableCell,
  DialogTitle, Box,
  Typography,
  TextField,
  FormControl,
  FormControlLabel,
  RadioGroup,
} from '@material-ui/core';
import {
  Search, Add, Refresh, NavigateNext,
} from '@material-ui/icons';
import validator, { VALIDATOR_CONST } from '../../../common/validator';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import {
  setCompanyResult, // 検索ボタン押下して取得した検索結果
  // 販売
  setCustomerCompanyCondition, // 設定ボタン押下して確定した検索条件
  setCustomerCompanyAddCondition, // 追加ボタン押下して選択内容に追加した条件
  setCustomerCompanyDisplayCondition, // 表示用
  // 仕入れ
  setSupplierCompanyCondition, // 設定ボタン押下して確定した検索条件
  setSupplierCompanyAddCondition, // 追加ボタン押下して選択内容に追加した条件
  setSupplierCompanyDisplayCondition, // 表示用
  // 国内最上位親会社
  setTopCompanyCondition, // 設定ボタン押下して確定した検索条件
  setTopCompanyAddCondition, // 追加ボタン押下して選択内容に追加した条件
  setTopCompanyDisplayCondition, // 表示用
  setCompanyPopFlg,
  setCompanyDunsKeyword,
  setCompanyTsrKeyword,
  setCompanyNameKeyword,
  setCompanyHojinKeyword,
  setErrMsgCompanyDunsKeyword,
  setErrMsgCompanyTsrKeyword,
  setErrMsgCompanyNameKeyword,
  setErrMsgCompanyHojinKeyword,
  setCheckCompanyDunsKeyword,
  setCheckCompanyTsrKeyword,
  setCheckCompanyNameKeyword,
  setCheckCompanyHojinKeyword,
  setErrMsgCompanyDuplicate,
  setGetCustomerCompanyFlg,
  setGetSupplierCompanyFlg,
  setGetTopCompanyFlg,
  setCompanyPopBtn,
  searchCompany,
  setCompanyNameSearchType,
} from '../../actions/TargetAction';
import {
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import {
  GET_MASTER_FLG,
  COMPANY_POP_KBN,
  SEARCH_KBN,
  PATTERN_MATCH,
  DUNS_NOT_USED_FLG,
  ADD_LIMIT_COUNT,
} from '../../../common/const';
import styles from './PopStyles.module.css';
import CustomRadio from '../common/CustomRadio';

class TargetPopSearchIndustryComponent extends Component {
  componentDidMount = async () => {
    const {
      setCustomerCompanyAddConditionAct,
      setSupplierCompanyAddConditionAct,
      setTopCompanyAddConditionAct,
      setCustomerCompanyDisplayConditionAct,
      setSupplierCompanyDisplayConditionAct,
      setTopCompanyDisplayConditionAct,
      setCustomerCompanyConditionAct,
      setSupplierCompanyConditionAct,
      setTopCompanyConditionAct,
      customerCompanyCondition,
      supplierCompanyCondition,
      topCompanyCondition,
      getCustomerCompanyFlg,
      getSupplierCompanyFlg,
      getTopCompanyFlg,
      setGetCustomerCompanyFlgAct,
      setGetSupplierCompanyFlgAct,
      setGetTopCompanyFlgAct,
      companyPopBtn,
      companyPopFlg,
      searchCompanyAct,
      setCompanyResultAct,
      setCompanyNameSearchTypeAct,
    } = this.props;

    // ターゲティング条件を選択した場合、選択内容取得
    if (companyPopFlg) {
      if (companyPopBtn === COMPANY_POP_KBN.CUSTOMER
        && getCustomerCompanyFlg === GET_MASTER_FLG.ON) {
        // 販売先
        const res = await searchCompanyAct(
          null,
          customerCompanyCondition,
          null,
          null,
          PATTERN_MATCH.EXACT,
          SEARCH_KBN.REFLECTED_TARGET_CONDITIONS,
        );

        if (res) {
          const newSetCustomerCompanyCondition = [];
          const newSetCustomerCompanyAddCondition = [];

          res.company_list.forEach((item) => {
            const cList = String(item.condition).split('：');
            const customerCompanyConditions = {
              kcd: cList[0],
            };
            newSetCustomerCompanyCondition.push(customerCompanyConditions);

            const customerCompanyAddConditions = {
              kcd: cList[0],
              trade_name: cList[1],
              condition: item.condition,
            };
            newSetCustomerCompanyAddCondition.push(customerCompanyAddConditions);
          });

          setCustomerCompanyConditionAct(newSetCustomerCompanyCondition);
          setCustomerCompanyAddConditionAct(newSetCustomerCompanyAddCondition);
          setCustomerCompanyDisplayConditionAct(newSetCustomerCompanyAddCondition);
          setGetCustomerCompanyFlgAct(GET_MASTER_FLG.OFF);
        }
      } else if (companyPopBtn === COMPANY_POP_KBN.SUPPLIER
        && getSupplierCompanyFlg === GET_MASTER_FLG.ON) {
        // 仕入先
        const res = await searchCompanyAct(
          null,
          supplierCompanyCondition,
          null,
          null,
          PATTERN_MATCH.EXACT,
          SEARCH_KBN.REFLECTED_TARGET_CONDITIONS,
        );
        if (res) {
          const newSetSupplierCompanyCondition = [];
          const newSetSupplierCompanyAddCondition = [];

          res.company_list.forEach((item) => {
            const cList = String(item.condition).split('：');
            const supplierCompanyConditions = {
              kcd: cList[0],
            };
            newSetSupplierCompanyCondition.push(supplierCompanyConditions);

            const supplierCompanyAddConditions = {
              kcd: cList[0],
              trade_name: cList[1],
              condition: item.condition,
            };
            newSetSupplierCompanyAddCondition.push(supplierCompanyAddConditions);
          });

          setSupplierCompanyConditionAct(newSetSupplierCompanyCondition);
          setSupplierCompanyAddConditionAct(newSetSupplierCompanyAddCondition);
          setSupplierCompanyDisplayConditionAct(newSetSupplierCompanyAddCondition);
          setGetSupplierCompanyFlgAct(GET_MASTER_FLG.OFF);
        }
      } else if (companyPopBtn === COMPANY_POP_KBN.TOPCOMPANY
        && getTopCompanyFlg === GET_MASTER_FLG.ON) {
        // 国内最上位親会社
        const res = await searchCompanyAct(
          null,
          topCompanyCondition,
          null,
          null,
          PATTERN_MATCH.EXACT,
          SEARCH_KBN.REFLECTED_TARGET_CONDITIONS,
        );
        if (res) {
          const newSetTopCompanyCondition = [];
          const newSetTopCompanyAddCondition = [];

          res.company_list.forEach((item) => {
            const cList = String(item.condition).split('：');
            const topCompanyConditions = {
              kcd: cList[0],
            };
            newSetTopCompanyCondition.push(topCompanyConditions);

            const topCompanyAddConditions = {
              kcd: cList[0],
              trade_name: cList[1],
              condition: item.condition,
            };
            newSetTopCompanyAddCondition.push(topCompanyAddConditions);
          });

          setTopCompanyConditionAct(newSetTopCompanyCondition);
          setTopCompanyAddConditionAct(newSetTopCompanyAddCondition);
          setTopCompanyDisplayConditionAct(newSetTopCompanyAddCondition);
          setGetTopCompanyFlgAct(GET_MASTER_FLG.OFF);
        }
      }
    }

    // 検索結果クリア
    setCompanyResultAct();
    setCompanyNameSearchTypeAct(PATTERN_MATCH.EXACT);
  }

  /**
   * 企業選択POPUPをclose
   */
  closeCompanyPop = () => {
    const { setCompanyPopFlgAct } = this.props;
    setCompanyPopFlgAct(false);
  };

  /**
   * 検索ボタン押下
   */
  searchCompany = async (
    companyDunsKeyword,
    companyTsrKeyword,
    companyNameKeyword,
    companyHojinKeyword,
    companyNameSearchType,
  ) => {
    const {
      searchCompanyAct,
      setCompanyResultAct,
      setErrMsgCompanyDuplicateAct,
      setSystemLodingFLgAct,
    } = this.props;

    // エラーメッセージを初期化
    setErrMsgCompanyDuplicateAct();
    setSystemLodingFLgAct(true);

    // DUNS
    let dunsKeyword = '';
    if (companyDunsKeyword) {
      dunsKeyword = companyDunsKeyword;
    }
    // TSRコード
    const tsrKeyword = [];
    if (companyTsrKeyword) {
      tsrKeyword.push(companyTsrKeyword);
    }
    // 企業名
    let nameKeyword = '';
    if (companyNameKeyword) {
      nameKeyword = companyNameKeyword;
    }
    // 法人番号
    let hojinKeyword = '';
    if (companyHojinKeyword) {
      hojinKeyword = companyHojinKeyword;
    }

    // 企業を取得
    const result = await searchCompanyAct(
      dunsKeyword,
      tsrKeyword,
      nameKeyword,
      hojinKeyword,
      companyNameSearchType,
      SEARCH_KBN.POPUP_LIST_SEARCH,
    );

    // 結果をセット
    setCompanyResultAct(result);
    setSystemLodingFLgAct(false);
  }

  /**
   * 条件クリアボタン押下
   */
  clear = () => {
    const {
      setCompanyDunsKeywordAct,
      setCompanyTsrKeywordAct,
      setCompanyNameKeywordAct,
      setCompanyHojinKeywordAct,
      setErrMsgCompanyTsrKeywordAct,
      setErrMsgCompanyHojinKeywordAct,
      setErrMsgCompanyDunsKeywordAct,
      setErrMsgCompanyNameKeywordAct,
      setCheckCompanyNameKeywordAct,
      setCheckCompanyTsrKeywordAct,
      setCheckCompanyHojinKeywordAct,
      setCheckCompanyDunsKeywordAct,
      setErrMsgCompanyDuplicateAct,
      setCompanyResultAct,
      setCompanyNameSearchTypeAct,
    } = this.props;

    // 検索条件を初期化
    setCompanyResultAct();
    setCompanyDunsKeywordAct();
    setCompanyTsrKeywordAct();
    setCompanyNameKeywordAct();
    setCompanyHojinKeywordAct();
    setCompanyNameSearchTypeAct(PATTERN_MATCH.EXACT);
    // キーワード桁数チェック
    // エラーメッセージ、エラーフラグを解除
    setErrMsgCompanyTsrKeywordAct();
    setErrMsgCompanyHojinKeywordAct();
    setErrMsgCompanyDunsKeywordAct();
    setErrMsgCompanyNameKeywordAct();
    setCheckCompanyNameKeywordAct(false);
    setCheckCompanyTsrKeywordAct(false);
    setCheckCompanyHojinKeywordAct(false);
    setCheckCompanyDunsKeywordAct(false);
    setErrMsgCompanyDuplicateAct();
  }

  /**
   * 追加ボタン押下
   */
  addCondition = (index) => {
    const {
      companyResult,
      customerCompanyAddCondition,
      supplierCompanyAddCondition,
      topCompanyAddCondition,
      setCustomerCompanyAddConditionAct,
      setSupplierCompanyAddConditionAct,
      setTopCompanyAddConditionAct,
      setErrMsgCompanyDuplicateAct,
      companyPopBtn,
    } = this.props;

    const addList = companyResult.company_list.filter((v, id) => id === index);
    const addConditionList = [];
    let addConditionItem;
    addList.forEach((item) => {
      addConditionItem = {
        kcd: item.kcd,
        trade_name: item.trade_name,
        condition: `${item.kcd}：${item.trade_name}`,
      };
      // 追加条件リストにセット
      addConditionList.push(addConditionItem);
    });

    if (companyPopBtn === COMPANY_POP_KBN.CUSTOMER) {
      // 販売先
      if (customerCompanyAddCondition) {
        // 選択内容に値が設定されている場合
        // 選択内容リスト
        const selectedConditionList = [];
        customerCompanyAddCondition.forEach((item) => selectedConditionList.push(item));

        // 重複チェック
        const msgs = [];

        addConditionList.forEach((addItem) => {
          // 追加条件リストの内容をチェックして、重複しないものだけ選択内容リストに追加
          if (!selectedConditionList.some((selectItem) => selectItem.kcd === addItem.kcd)) {
            if (selectedConditionList.length === ADD_LIMIT_COUNT.COMPANY) {
              setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02005));
            } else {
              selectedConditionList.push(addItem);
              // エラーメッセージを初期化
              setErrMsgCompanyDuplicateAct();
            }
          } else {
            // 重複している場合、エラーメッセージを表示
            // エラーメッセージを設定
            setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02004, msgs.join(',')));
          }
        });
        setCustomerCompanyAddConditionAct(selectedConditionList);
      } else {
        // 選択内容に値が設定されていない場合
        // エラーメッセージを初期化
        setErrMsgCompanyDuplicateAct();
        setCustomerCompanyAddConditionAct(addConditionList);
      }
    } else if (companyPopBtn === COMPANY_POP_KBN.SUPPLIER) {
      // 仕入先
      if (supplierCompanyAddCondition) {
        // 選択内容に値が設定されている場合

        // 選択内容リスト
        const selectedConditionList = [];
        supplierCompanyAddCondition.forEach((item) => selectedConditionList.push(item));

        // 重複チェック
        const msgs = [];

        addConditionList.forEach((addItem) => {
          // 追加条件リストの内容をチェックして、重複しないものだけ選択内容リストに追加
          if (!selectedConditionList.some((selectItem) => selectItem.kcd === addItem.kcd)) {
            if (selectedConditionList.length === ADD_LIMIT_COUNT.COMPANY) {
              setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02005));
            } else {
              selectedConditionList.push(addItem);
              // エラーメッセージを初期化
              setErrMsgCompanyDuplicateAct();
            }
          } else {
            // 重複している場合、エラーメッセージを表示
            // エラーメッセージを設定
            setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02004, msgs.join(',')));
          }
        });
        setSupplierCompanyAddConditionAct(selectedConditionList);
      } else {
        // 選択内容に値が設定されていない場合
        // エラーメッセージを初期化
        setErrMsgCompanyDuplicateAct();
        setSupplierCompanyAddConditionAct(addConditionList);
      }
    } else if (companyPopBtn === COMPANY_POP_KBN.TOPCOMPANY) {
      // 国内最上位親会社
      if (topCompanyAddCondition) {
        // 選択内容に値が設定されている場合

        // 選択内容リスト
        const selectedConditionList = [];
        topCompanyAddCondition.forEach((item) => selectedConditionList.push(item));

        // 重複チェック
        const msgs = [];

        addConditionList.forEach((addItem) => {
          // 追加条件リストの内容をチェックして、重複しないものだけ選択内容リストに追加
          if (!selectedConditionList.some((selectItem) => selectItem.kcd === addItem.kcd)) {
            if (selectedConditionList.length === ADD_LIMIT_COUNT.COMPANY) {
              setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02005));
            } else {
              selectedConditionList.push(addItem);
              // エラーメッセージを初期化
              setErrMsgCompanyDuplicateAct();
            }
          } else {
            // 重複している場合、エラーメッセージを表示
            // エラーメッセージを設定
            setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02004, msgs.join(',')));
          }
        });
        setTopCompanyAddConditionAct(selectedConditionList);
      } else {
        // 選択内容に値が設定されていない場合
        // エラーメッセージを初期化
        setErrMsgCompanyDuplicateAct();
        setTopCompanyAddConditionAct(addConditionList);
      }
    }
  }

  /**
   * 全て選択ボタン押下
   */
  addAllCondition = () => {
    const {
      companyResult,
      customerCompanyAddCondition,
      supplierCompanyAddCondition,
      topCompanyAddCondition,
      setCustomerCompanyAddConditionAct,
      setSupplierCompanyAddConditionAct,
      setTopCompanyAddConditionAct,
      setErrMsgCompanyDuplicateAct,
      companyPopBtn,
    } = this.props;

    // 検索結果がnullかつ空では無い場合
    if (companyResult && Object.keys(companyResult).length !== 0) {
      const addConditionList = [];
      let addConditionItem;
      companyResult.company_list.forEach((item) => {
        addConditionItem = {
          kcd: item.kcd,
          trade_name: item.trade_name,
          condition: `${item.kcd}：${item.trade_name}`,
        };
        // 追加条件リストにセット
        addConditionList.push(addConditionItem);
      });

      if (companyPopBtn === COMPANY_POP_KBN.CUSTOMER) {
        // 販売先
        if (customerCompanyAddCondition) {
          // 選択内容に値が設定されている場合

          // 選択内容リスト
          const selectedConditionList = [];
          customerCompanyAddCondition.forEach((item) => selectedConditionList.push(item));

          // 重複チェック
          let hasDuplicate = false;
          const msgs = [];

          addConditionList.forEach((addItem) => {
            // 追加条件リストの内容をチェックして、重複しないものだけ選択内容リストに追加
            if (!selectedConditionList.some((selectItem) => selectItem.kcd === addItem.kcd)) {
              selectedConditionList.push(addItem);
            } else {
              // 重複データが存在する場合
              hasDuplicate = true;
            }
          });
          if (selectedConditionList.length > ADD_LIMIT_COUNT.COMPANY) {
            setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02005));
          } else {
            if (hasDuplicate) {
              // 重複データが存在する場合
              // エラーメッセージを設定
              setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02004, msgs.join(',')));
            } else {
              // 重複データが存在しない場合
              // エラーメッセージを初期化
              setErrMsgCompanyDuplicateAct();
            }

            setCustomerCompanyAddConditionAct(selectedConditionList);
          }
        } else if (addConditionList.length > ADD_LIMIT_COUNT.COMPANY) {
          setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02005));
        } else {
          // 選択内容に値が設定されていない場合
          // エラーメッセージを初期化
          setErrMsgCompanyDuplicateAct();
          setCustomerCompanyAddConditionAct(addConditionList);
        }
      } else if (companyPopBtn === COMPANY_POP_KBN.SUPPLIER) {
        if (supplierCompanyAddCondition) {
          // 選択内容に値が設定されている場合

          // 選択内容リスト
          const selectedConditionList = [];
          supplierCompanyAddCondition.forEach((item) => selectedConditionList.push(item));

          // 重複チェック
          let hasDuplicate = false;
          const msgs = [];

          addConditionList.forEach((addItem) => {
            // 追加条件リストの内容をチェックして、重複しないものだけ選択内容リストに追加
            if (!selectedConditionList.some((selectItem) => selectItem.kcd === addItem.kcd)) {
              selectedConditionList.push(addItem);
            } else {
              // 重複データが存在する場合
              hasDuplicate = true;
            }
          });
          if (selectedConditionList.length > ADD_LIMIT_COUNT.COMPANY) {
            setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02005));
          } else {
            if (hasDuplicate) {
              // 重複データが存在する場合
              // エラーメッセージを設定
              setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02004, msgs.join(',')));
            } else {
              // 重複データが存在しない場合
              // エラーメッセージを初期化
              setErrMsgCompanyDuplicateAct();
            }

            setSupplierCompanyAddConditionAct(selectedConditionList);
          }
        } else if (addConditionList.length > ADD_LIMIT_COUNT.COMPANY) {
          setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02005));
        } else {
          // 選択内容に値が設定されていない場合
          // エラーメッセージを初期化
          setErrMsgCompanyDuplicateAct();
          setSupplierCompanyAddConditionAct(addConditionList);
        }
      } else if (companyPopBtn === COMPANY_POP_KBN.TOPCOMPANY) {
        if (topCompanyAddCondition) {
          // 選択内容に値が設定されている場合

          // 選択内容リスト
          const selectedConditionList = [];
          topCompanyAddCondition.forEach((item) => selectedConditionList.push(item));

          // 重複チェック
          let hasDuplicate = false;
          const msgs = [];

          addConditionList.forEach((addItem) => {
            // 追加条件リストの内容をチェックして、重複しないものだけ選択内容リストに追加
            if (!selectedConditionList.some((selectItem) => selectItem.kcd === addItem.kcd)) {
              selectedConditionList.push(addItem);
            } else {
              // 重複データが存在する場合
              hasDuplicate = true;
            }
          });

          if (selectedConditionList.length > ADD_LIMIT_COUNT.COMPANY) {
            setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02005));
          } else {
            if (hasDuplicate) {
              // 重複データが存在する場合
              // エラーメッセージを設定
              setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02004, msgs.join(',')));
            } else {
              // 重複データが存在しない場合
              // エラーメッセージを初期化
              setErrMsgCompanyDuplicateAct();
            }

            setTopCompanyAddConditionAct(selectedConditionList);
          }
        } else if (addConditionList.length > ADD_LIMIT_COUNT.COMPANY) {
          setErrMsgCompanyDuplicateAct(getMessage(ERROR.E02005));
        } else {
          // 選択内容に値が設定されていない場合
          // エラーメッセージを初期化
          setErrMsgCompanyDuplicateAct();
          setTopCompanyAddConditionAct(addConditionList);
        }
      }
    }
  }

  /**
   * 削除ボタン押下
   */
  deleteCondition = (kcd) => {
    const {
      customerCompanyAddCondition,
      supplierCompanyAddCondition,
      topCompanyAddCondition,
      setCustomerCompanyAddConditionAct,
      setSupplierCompanyAddConditionAct,
      setTopCompanyAddConditionAct,
      setErrMsgCompanyDuplicateAct,
      companyPopBtn,
    } = this.props;

    // エラーメッセージを初期化
    setErrMsgCompanyDuplicateAct();

    if (companyPopBtn === COMPANY_POP_KBN.CUSTOMER) {
      const newAddCondition = customerCompanyAddCondition.filter((v) => v.kcd !== kcd);
      setCustomerCompanyAddConditionAct(newAddCondition);
    } else if (companyPopBtn === COMPANY_POP_KBN.SUPPLIER) {
      const newAddCondition = supplierCompanyAddCondition.filter((v) => v.kcd !== kcd);
      setSupplierCompanyAddConditionAct(newAddCondition);
    } else if (companyPopBtn === COMPANY_POP_KBN.TOPCOMPANY) {
      const newAddCondition = topCompanyAddCondition.filter((v) => v.kcd !== kcd);
      setTopCompanyAddConditionAct(newAddCondition);
    }
  }

  /**
   * 設定ボタン押下
   */
  setCondition = () => {
    const {
      setCompanyDunsKeywordAct,
      setCompanyTsrKeywordAct,
      setCompanyNameKeywordAct,
      setCompanyHojinKeywordAct,
      setErrMsgCompanyTsrKeywordAct,
      setErrMsgCompanyHojinKeywordAct,
      setErrMsgCompanyDunsKeywordAct,
      setErrMsgCompanyNameKeywordAct,
      setErrMsgCompanyDuplicateAct,
      setCheckCompanyNameKeywordAct,
      setCheckCompanyTsrKeywordAct,
      setCheckCompanyHojinKeywordAct,
      setCheckCompanyDunsKeywordAct,
      setCustomerCompanyDisplayConditionAct,
      setSupplierCompanyDisplayConditionAct,
      setTopCompanyDisplayConditionAct,
      setCustomerCompanyConditionAct,
      setSupplierCompanyConditionAct,
      setTopCompanyConditionAct,
      customerCompanyAddCondition,
      supplierCompanyAddCondition,
      topCompanyAddCondition,
      companyPopBtn,

    } = this.props;

    if (companyPopBtn === COMPANY_POP_KBN.CUSTOMER) {
      // 選択内容一覧がnullではない場合
      if (customerCompanyAddCondition) {
        const newSetCompanyCondition = [];
        customerCompanyAddCondition.forEach((condition) => {
          const companyConditions = {
            kcd: condition.kcd,
          };
          newSetCompanyCondition.push(companyConditions);
        });

        setCustomerCompanyConditionAct(newSetCompanyCondition);
        setCustomerCompanyDisplayConditionAct(customerCompanyAddCondition);

        // 検索条件、検索結果、エラーメッセージ初期化
        setCompanyDunsKeywordAct();
        setCompanyTsrKeywordAct();
        setCompanyNameKeywordAct();
        setCompanyHojinKeywordAct();
        setErrMsgCompanyTsrKeywordAct();
        setErrMsgCompanyHojinKeywordAct();
        setErrMsgCompanyDunsKeywordAct();
        setErrMsgCompanyNameKeywordAct();
        setErrMsgCompanyDuplicateAct();
        setCheckCompanyNameKeywordAct(false);
        setCheckCompanyTsrKeywordAct(false);
        setCheckCompanyHojinKeywordAct(false);
        setCheckCompanyDunsKeywordAct(false);

        // ポップアップを閉じる
        this.closeCompanyPop();
      }
    } else if (companyPopBtn === COMPANY_POP_KBN.SUPPLIER) {
      // 選択内容一覧がnullではない場合
      if (supplierCompanyAddCondition) {
        const newSetCompanyCondition = [];
        supplierCompanyAddCondition.forEach((condition) => {
          const companyConditions = {
            kcd: condition.kcd,
          };
          newSetCompanyCondition.push(companyConditions);
        });

        setSupplierCompanyConditionAct(newSetCompanyCondition);
        setSupplierCompanyDisplayConditionAct(supplierCompanyAddCondition);

        // 検索条件、検索結果、エラーメッセージ初期化
        setCompanyDunsKeywordAct();
        setCompanyTsrKeywordAct();
        setCompanyNameKeywordAct();
        setCompanyHojinKeywordAct();
        setErrMsgCompanyTsrKeywordAct();
        setErrMsgCompanyHojinKeywordAct();
        setErrMsgCompanyDunsKeywordAct();
        setErrMsgCompanyNameKeywordAct();
        setCheckCompanyNameKeywordAct(false);
        setCheckCompanyTsrKeywordAct(false);
        setCheckCompanyHojinKeywordAct(false);
        setCheckCompanyDunsKeywordAct(false);

        // ポップアップを閉じる
        this.closeCompanyPop();
      }
    } else if (companyPopBtn === COMPANY_POP_KBN.TOPCOMPANY) {
      // 選択内容一覧がnullではない場合
      if (topCompanyAddCondition) {
        const newSetCompanyCondition = [];
        topCompanyAddCondition.forEach((condition) => {
          const companyConditions = {
            kcd: condition.kcd,
          };
          newSetCompanyCondition.push(companyConditions);
        });

        setTopCompanyConditionAct(newSetCompanyCondition);
        setTopCompanyDisplayConditionAct(topCompanyAddCondition);

        // 検索条件、検索結果、エラーメッセージ初期化
        setCompanyDunsKeywordAct();
        setCompanyTsrKeywordAct();
        setCompanyNameKeywordAct();
        setCompanyHojinKeywordAct();
        setErrMsgCompanyTsrKeywordAct();
        setErrMsgCompanyHojinKeywordAct();
        setErrMsgCompanyDunsKeywordAct();
        setErrMsgCompanyNameKeywordAct();
        setCheckCompanyNameKeywordAct(false);
        setCheckCompanyTsrKeywordAct(false);
        setCheckCompanyHojinKeywordAct(false);
        setCheckCompanyDunsKeywordAct(false);

        // ポップアップを閉じる
        this.closeCompanyPop();
      }
    }
  }

  /**
   * キャンセルボタン押下
   */
  cancel = () => {
    const {
      setCompanyDunsKeywordAct,
      setCompanyTsrKeywordAct,
      setCompanyNameKeywordAct,
      setCompanyHojinKeywordAct,
      setErrMsgCompanyDuplicateAct,
      setErrMsgCompanyTsrKeywordAct,
      setErrMsgCompanyHojinKeywordAct,
      setErrMsgCompanyDunsKeywordAct,
      setErrMsgCompanyNameKeywordAct,
      setCheckCompanyNameKeywordAct,
      setCheckCompanyTsrKeywordAct,
      setCheckCompanyHojinKeywordAct,
      setCheckCompanyDunsKeywordAct,
    } = this.props;

    // 検索条件、検索結果、エラーメッセージ初期化
    setCompanyDunsKeywordAct();
    setCompanyTsrKeywordAct();
    setCompanyNameKeywordAct();
    setCompanyHojinKeywordAct();
    setErrMsgCompanyTsrKeywordAct();
    setErrMsgCompanyHojinKeywordAct();
    setErrMsgCompanyDunsKeywordAct();
    setErrMsgCompanyNameKeywordAct();
    setErrMsgCompanyDuplicateAct();
    setCheckCompanyNameKeywordAct(false);
    setCheckCompanyTsrKeywordAct(false);
    setCheckCompanyHojinKeywordAct(false);
    setCheckCompanyDunsKeywordAct(false);

    // ポップアップを閉じる
    this.closeCompanyPop();
  }

  /**
    *企業名 最大桁数のチェック
    */
  onBlurNameKeyword = () => {
    const {
      companyNameKeyword,
      setCheckCompanyNameKeywordAct,
      setErrMsgCompanyNameKeywordAct,
    } = this.props;

    // 入力チェック
    const msgs = [];
    validator.checkMaxLength(companyNameKeyword, 100, msgs);

    if (msgs.length !== 0) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgCompanyNameKeywordAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckCompanyNameKeywordAct(true);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setCheckCompanyNameKeywordAct();
    setErrMsgCompanyNameKeywordAct(false);
  }

  /**
  *TSRコード 最大桁数のチェック
  */
  onBlurTsrKeyword = () => {
    const {
      companyTsrKeyword,
      setCheckCompanyTsrKeywordAct,
      setErrMsgCompanyTsrKeywordAct,
    } = this.props;

    // 入力チェック
    const msgs = [];
    validator.checkChar(companyTsrKeyword, VALIDATOR_CONST.PATERN_NUM, msgs);
    validator.checkLength(companyTsrKeyword, 9, msgs);

    if (msgs.length !== 0) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgCompanyTsrKeywordAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckCompanyTsrKeywordAct(true);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgCompanyTsrKeywordAct();
    setCheckCompanyTsrKeywordAct(false);
  }

  /**
  *法人番号 最大桁数のチェック
  */
  onBlurHojinKeyword = () => {
    const {
      companyHojinKeyword,
      setCheckCompanyHojinKeywordAct,
      setErrMsgCompanyHojinKeywordAct,
    } = this.props;

    // 入力チェック
    const msgs = [];
    validator.checkChar(companyHojinKeyword, VALIDATOR_CONST.PATERN_NUM, msgs);
    validator.checkLength(companyHojinKeyword, 13, msgs);

    if (msgs.length !== 0) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgCompanyHojinKeywordAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckCompanyHojinKeywordAct(true);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setCheckCompanyHojinKeywordAct();
    setErrMsgCompanyHojinKeywordAct(false);
  }

  /**
  *DUNS 最大桁数のチェック
  */
  onBlurDunsKeyword = () => {
    const {
      companyDunsKeyword,
      setCheckCompanyDunsKeywordAct,
      setErrMsgCompanyDunsKeywordAct,
    } = this.props;

    // 入力チェック
    const msgs = [];
    validator.checkChar(companyDunsKeyword, VALIDATOR_CONST.PATERN_NUM, msgs);
    validator.checkLength(companyDunsKeyword, 9, msgs);

    if (msgs.length !== 0) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgCompanyDunsKeywordAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckCompanyDunsKeywordAct(true);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setCheckCompanyDunsKeywordAct();
    setErrMsgCompanyDunsKeywordAct(false);
  }

  render() {
    const {
      companyResult,
      customerCompanyAddCondition,
      supplierCompanyAddCondition,
      topCompanyAddCondition,
      errMsgCompanyDunsKeyword,
      errMsgCompanyTsrKeyword,
      errMsgCompanyNameKeyword,
      errMsgCompanyHojinKeyword,
      errMsgCompanyDuplicate,
      checkErrFlg,
      companyPopFlg,
      companyDunsKeyword,
      companyTsrKeyword,
      companyNameKeyword,
      companyHojinKeyword,
      setCompanyDunsKeywordAct,
      setCompanyTsrKeywordAct,
      setCompanyNameKeywordAct,
      setCompanyHojinKeywordAct,
      companyPopBtn,
      companyNameSearchType,
      setCompanyNameSearchTypeAct,
      userInfo,
    } = this.props;

    return (companyPopFlg && (
      <Box className={`${styles.dialog}`}>
        <Box className={`${styles.contents}`}>
          <Box className={`${styles.marginBottomHalf}`}>
            <DialogTitle>企業選択</DialogTitle>
          </Box>
          <Box className={`${styles.height2} ${styles.display}`}>
            <span className={`${styles.errorMsg}`}>{errMsgCompanyDuplicate}</span>
          </Box>
          <Box className={`${styles.searchconditionareaIndustry}`}>
            <Box className={`${styles.condition}  ${styles.industrySelect}`}>
              <Box className={`${styles.conditionTitle}`}>TSRコード</Box>
              <Box className={`${styles.conditionValueTsrCd}`}>
                <TextField
                  InputProps={{ classes: { input: styles.inputSizing } }}
                  value={companyTsrKeyword || ''}
                  onChange={(ev) => setCompanyTsrKeywordAct(ev.target.value)}
                  onBlur={this.onBlurTsrKeyword}
                  variant="outlined"
                  error={checkErrFlg.checkCompanyTsrKeyword}
                />
                {checkErrFlg.checkCompanyTsrKeyword
                  && (
                    <div className={`${styles.baloon}`}>
                      <div className={`${styles.triangleTsr}`}>
                        <div className={`${styles.triangleDiv}`} />
                      </div>
                      <div className={`${styles.babbleTsr}`}>
                        {errMsgCompanyTsrKeyword}
                      </div>
                    </div>
                  )}
              </Box>
              {userInfo.duns_not_used_flag !== DUNS_NOT_USED_FLG.ON && (
                <>
                  <Box className={`${styles.conditionTitle}`}>D&B D-U-N-S® Number</Box>
                  <Box className={`${styles.conditionValueDuns}`}>
                    <TextField
                      InputProps={{ classes: { input: styles.inputSizing } }}
                      value={companyDunsKeyword || ''}
                      onChange={(ev) => setCompanyDunsKeywordAct(ev.target.value)}
                      onBlur={this.onBlurDunsKeyword}
                      variant="outlined"
                      error={checkErrFlg.checkCompanyDunsKeyword}
                    />
                    {checkErrFlg.checkCompanyDunsKeyword
                      && (
                        <div className={`${styles.baloon}`}>
                          <div className={`${styles.triangleDuns}`}>
                            <div className={`${styles.triangleDiv}`} />
                          </div>
                          <div className={`${styles.babbleDuns}`}>
                            {errMsgCompanyDunsKeyword}
                          </div>
                        </div>
                      )}
                  </Box>
                </>
              )}
              <Box className={`${styles.conditionTitle}`}>法人番号</Box>
              <Box className={`${styles.conditionValueHjnNo}`}>
                <TextField
                  InputProps={{ classes: { input: styles.inputSizing } }}
                  value={companyHojinKeyword || ''}
                  onChange={(ev) => setCompanyHojinKeywordAct(ev.target.value)}
                  onBlur={this.onBlurHojinKeyword}
                  variant="outlined"
                  error={checkErrFlg.checkCompanyHojinKeyword}
                />
                {checkErrFlg.checkCompanyHojinKeyword
                  && (
                    <div className={`${styles.baloon}`}>
                      <div className={`${styles.triangleHjnNo}`}>
                        <div className={`${styles.triangleDiv}`} />
                      </div>
                      <div className={`${styles.babbleHjnNo}`}>
                        {errMsgCompanyHojinKeyword}
                      </div>
                    </div>
                  )}
              </Box>
            </Box>
            <Box className={`${styles.condition}`}>
              <Box className={`${styles.conditionTitle}`}>企業名</Box>
              <Box className={`${styles.conditionValue}`}>
                <TextField
                  InputProps={{ classes: { input: styles.inputSizing } }}
                  value={companyNameKeyword || ''}
                  onChange={(ev) => setCompanyNameKeywordAct(ev.target.value)}
                  onBlur={this.onBlurNameKeyword}
                  variant="outlined"
                  error={checkErrFlg.checkCompanyNameKeyword}
                />
                {checkErrFlg.checkCompanyNameKeyword
                  && (
                    <div className={`${styles.baloon}`}>
                      <div className={`${styles.triangle}`}>
                        <div className={`${styles.triangleDiv}`} />
                      </div>
                      <div className={`${styles.babble}`}>
                        {errMsgCompanyNameKeyword}
                      </div>
                    </div>
                  )}
              </Box>
              <FormControl component="fieldset">
                <RadioGroup row>
                  <FormControlLabel
                    value={PATTERN_MATCH.EXACT}
                    control={<CustomRadio />}
                    label="完全一致"
                    checked={companyNameSearchType === PATTERN_MATCH.EXACT}
                    onChange={() => setCompanyNameSearchTypeAct(PATTERN_MATCH.EXACT)}
                  />
                  <FormControlLabel
                    value={PATTERN_MATCH.PART}
                    control={<CustomRadio />}
                    label="部分一致"
                    checked={companyNameSearchType === PATTERN_MATCH.PART}
                    onChange={() => setCompanyNameSearchTypeAct(PATTERN_MATCH.PART)}
                    className={`${styles.marginLeft1}`}
                  />
                </RadioGroup>
              </FormControl>
              <Box className={`${styles.conditionButton}`}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Refresh />}
                  onClick={() => this.clear()}
                  className={`${styles.height2}`}
                >
                  条件クリア
                </Button>
              </Box>
              <Box className={`${styles.conditionButton}`}>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<Search />}
                  onClick={
                    () => this.searchCompany(
                      companyDunsKeyword,
                      companyTsrKeyword,
                      companyNameKeyword,
                      companyHojinKeyword,
                      companyNameSearchType,
                    )
                  }
                  className={`${styles.height2}`}
                  disabled={checkErrFlg.checkCompanyDunsKeyword
                    || checkErrFlg.checkCompanyHojinKeyword
                    || checkErrFlg.checkCompanyNameKeyword
                    || checkErrFlg.checkCompanyTsrKeyword}
                >
                  検索
                </Button>
              </Box>
            </Box>
          </Box>
          <Box className={`${styles.searchResultarea}`}>
            <div className={`${styles.searchResultareaTableHead}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableHead>
                  <TableRow>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader} ${styles.addDeleteCell}`}> </TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>TSR企業コード</TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>商号漢字</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </div>
            <div className={`${styles.searchResultareaTableBody}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableBody>
                  {companyResult
                    && companyResult.company_list
                    && companyResult.company_list.map((result, i) => (
                      <TableRow key={i}>
                        <TableCell className={`${styles.dialogTableCell} ${styles.addDeleteCell}`}>
                          <Button
                            variant="contained"
                            className={`${styles.tooltip} addDelete`}
                            onClick={() => this.addCondition(i)}
                          >
                            <span>＋</span>
                            <Box className={`${styles.description}`}>検索条件に追加</Box>
                          </Button>
                        </TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{result.kcd}</TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{result.trade_name}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </div>
          </Box>
          <Box className={`${styles.listSpacerArea}`}>
            <Box className={`${styles.addAllArea}`}>
              <Button
                variant="contained"
                onClick={() => this.addAllCondition()}
                startIcon={<Add />}
                className={`${styles.displayFlex} ${styles.height2} addAll`}
              >
                全て選択
              </Button>
            </Box>
            <Box className={`${styles.arrowDown}`}>
              <Typography className={`${styles.fontSize}`}>≫</Typography>
            </Box>
          </Box>
          <Box className={`${styles.productsCondition}`}>
            <div className={`${styles.productsconditionTableHead}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableHead>
                  <TableRow>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.conditionlistHeader} ${styles.addDeleteCell}`}> </TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.conditionlistHeader}`}>選択内容</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </div>
            <div className={`${styles.productsconditionTableBody}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableBody>
                  {companyPopBtn === COMPANY_POP_KBN.CUSTOMER && customerCompanyAddCondition
                    && customerCompanyAddCondition.map((selectCondition, i) => (
                      <TableRow key={i}>
                        <TableCell className={`${styles.dialogTableCell} ${styles.addDeleteCell}`}>
                          <Button
                            variant="contained"
                            className={`${styles.tooltip} addDelete`}
                            onClick={() => this.deleteCondition(selectCondition.kcd)}
                          >
                            <span>－</span>
                            <Box className={`${styles.description}`}>検索条件から削除</Box>
                          </Button>
                        </TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{selectCondition.condition}</TableCell>
                      </TableRow>
                    ))}
                  {companyPopBtn === COMPANY_POP_KBN.SUPPLIER && supplierCompanyAddCondition
                    && supplierCompanyAddCondition.map((selectCondition, i) => (
                      <TableRow key={i}>
                        <TableCell className={`${styles.dialogTableCell} ${styles.addDeleteCell}`}>
                          <Button
                            variant="contained"
                            className={`${styles.tooltip} addDelete`}
                            onClick={() => this.deleteCondition(selectCondition.kcd)}
                          >
                            <span>－</span>
                            <Box className={`${styles.description}`}>検索条件から削除</Box>
                          </Button>
                        </TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{selectCondition.condition}</TableCell>
                      </TableRow>
                    ))}
                  {companyPopBtn === COMPANY_POP_KBN.TOPCOMPANY && topCompanyAddCondition
                    && topCompanyAddCondition.map((selectCondition, i) => (
                      <TableRow key={i}>
                        <TableCell className={`${styles.dialogTableCell} ${styles.addDeleteCell}`}>
                          <Button
                            variant="contained"
                            className={`${styles.tooltip} addDelete`}
                            onClick={() => this.deleteCondition(selectCondition.kcd)}
                          >
                            <span>－</span>
                            <Box className={`${styles.description}`}>検索条件から削除</Box>
                          </Button>
                        </TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{selectCondition.condition}</TableCell>
                      </TableRow>
                    ))}

                </TableBody>
              </Table>
            </div>
          </Box>
          <Box className={`${styles.buttonArea}`}>
            <Button
              variant="contained"
              className={`${styles.height2} cancel`}
              onClick={() => this.cancel()}
            >
              キャンセル
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className={`${styles.marginLeft1} ${styles.height2}`}
              onClick={() => this.setCondition()}
            >
              <NavigateNext className={`${styles.setButtonIcon}`} />
              設定
            </Button>
          </Box>
        </Box>
      </Box>
    ));
  }
}

export default connect(
  (state) => ({
    companyResult: state.target.companyResult,
    customerCompanyCondition: state.target.customerCompanyCondition,
    supplierCompanyCondition: state.target.supplierCompanyCondition,
    topCompanyCondition: state.target.topCompanyCondition,
    customerCompanyAddCondition: state.target.customerCompanyAddCondition,
    supplierCompanyAddCondition: state.target.supplierCompanyAddCondition,
    topCompanyAddCondition: state.target.topCompanyAddCondition,
    customerCompanyDisplayCondition: state.target.customerCompanyDisplayCondition,
    supplierCompanyDisplayCondition: state.target.supplierCompanyDisplayCondition,
    topCompanyDisplayCondition: state.target.topCompanyDisplayCondition,
    checkErrFlg: state.target.checkErrFlg,
    companyPopFlg: state.target.companyPopFlg,
    companyPopBtn: state.target.companyPopBtn,
    companyDunsKeyword: state.target.companyDunsKeyword,
    companyTsrKeyword: state.target.companyTsrKeyword,
    companyNameKeyword: state.target.companyNameKeyword,
    companyHojinKeyword: state.target.companyHojinKeyword,
    errMsgCompanyDunsKeyword: state.target.errMsgCompanyDunsKeyword,
    errMsgCompanyTsrKeyword: state.target.errMsgCompanyTsrKeyword,
    errMsgCompanyNameKeyword: state.target.errMsgCompanyNameKeyword,
    errMsgCompanyHojinKeyword: state.target.errMsgCompanyHojinKeyword,
    errMsgCompanyDuplicate: state.target.errMsgCompanyDuplicate,
    getCustomerCompanyFlg: state.target.getCustomerCompanyFlg,
    getSupplierCompanyFlg: state.target.getSupplierCompanyFlg,
    getTopCompanyFlg: state.target.getTopCompanyFlg,
    companyNameSearchType: state.target.companyNameSearchType,
    userInfo: state.common.userInfo,
  }),
  (dispatch) => ({
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setCompanyResultAct: (obj) => dispatch(setCompanyResult(obj)),
    setCustomerCompanyConditionAct: (obj) => dispatch(setCustomerCompanyCondition(obj)),
    setSupplierCompanyConditionAct: (obj) => dispatch(setSupplierCompanyCondition(obj)),
    setTopCompanyConditionAct: (obj) => dispatch(setTopCompanyCondition(obj)),
    setCustomerCompanyAddConditionAct: (obj) => dispatch(setCustomerCompanyAddCondition(obj)),
    setSupplierCompanyAddConditionAct: (obj) => dispatch(setSupplierCompanyAddCondition(obj)),
    setTopCompanyAddConditionAct: (obj) => dispatch(setTopCompanyAddCondition(obj)),
    setCustomerCompanyDisplayConditionAct: (obj) => dispatch(
      setCustomerCompanyDisplayCondition(obj),
    ),
    setSupplierCompanyDisplayConditionAct: (obj) => dispatch(
      setSupplierCompanyDisplayCondition(obj),
    ),
    setTopCompanyDisplayConditionAct: (obj) => dispatch(setTopCompanyDisplayCondition(obj)),
    setCompanyPopFlgAct: (bool) => dispatch(setCompanyPopFlg(bool)),
    setCompanyDunsKeywordAct: (str) => dispatch(setCompanyDunsKeyword(str)),
    setCompanyTsrKeywordAct: (str) => dispatch(setCompanyTsrKeyword(str)),
    setCompanyNameKeywordAct: (str) => dispatch(setCompanyNameKeyword(str)),
    setCompanyHojinKeywordAct: (str) => dispatch(setCompanyHojinKeyword(str)),
    setErrMsgCompanyDunsKeywordAct: (sr) => dispatch(setErrMsgCompanyDunsKeyword(sr)),
    setErrMsgCompanyTsrKeywordAct: (sr) => dispatch(setErrMsgCompanyTsrKeyword(sr)),
    setErrMsgCompanyNameKeywordAct: (sr) => dispatch(setErrMsgCompanyNameKeyword(sr)),
    setErrMsgCompanyHojinKeywordAct: (sr) => dispatch(setErrMsgCompanyHojinKeyword(sr)),
    setCheckCompanyDunsKeywordAct: (bool) => dispatch(setCheckCompanyDunsKeyword(bool)),
    setCheckCompanyTsrKeywordAct: (bool) => dispatch(setCheckCompanyTsrKeyword(bool)),
    setCheckCompanyNameKeywordAct: (bool) => dispatch(setCheckCompanyNameKeyword(bool)),
    setCheckCompanyHojinKeywordAct: (bool) => dispatch(setCheckCompanyHojinKeyword(bool)),
    setErrMsgCompanyDuplicateAct: (sr) => dispatch(setErrMsgCompanyDuplicate(sr)),
    setGetCustomerCompanyFlgAct: (str) => dispatch(setGetCustomerCompanyFlg(str)),
    setGetSupplierCompanyFlgAct: (str) => dispatch(setGetSupplierCompanyFlg(str)),
    setGetTopCompanyFlgAct: (str) => dispatch(setGetTopCompanyFlg(str)),
    setCompanyPopBtngAct: (str) => dispatch(setCompanyPopBtn(str)),
    searchCompanyAct: (
      dunsKeyword,
      tsrKeyword,
      nameKeyword,
      hojinKeyword,
      companyNameSearchType,
      searchType,
    ) => dispatch(searchCompany(dunsKeyword,
      tsrKeyword,
      nameKeyword,
      hojinKeyword,
      companyNameSearchType,
      searchType)),
    setCompanyNameSearchTypeAct: (str) => dispatch(setCompanyNameSearchType(str)),
  }),
)(TargetPopSearchIndustryComponent);
